import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import PageHero from '../../components/ui-shree/PageHero';

const ARTICLES = [
  {
    cat: 'Ingredient',
    title: 'Sea-buckthorn, and the sun the berry remembers',
    excerpt:
      'A meditation on the orange berry that ripens above 3,000m, and how it teaches our serums to behave like sunlight.',
    read: '6 min',
    image:
      'https://images.pexels.com/photos/4666755/pexels-photo-4666755.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900',
  },
  {
    cat: 'Ritual',
    title: 'On washing one\'s face slowly',
    excerpt:
      'A defence of the long, devotional cleanse. Why two minutes will change the way your skin speaks to you.',
    read: '4 min',
    image:
      'https://images.pexels.com/photos/3735619/pexels-photo-3735619.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900',
  },
  {
    cat: 'Provenance',
    title: 'A ledger written in linen',
    excerpt:
      'How we moved our notebook of harvests from a leather binder to an immutable chain — and what was kept, what was lost.',
    read: '8 min',
    image:
      'https://images.pexels.com/photos/4348404/pexels-photo-4348404.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900',
  },
  {
    cat: 'Atelier',
    title: 'Lot 042: a notebook from October',
    excerpt:
      'Three pages from our Heavener, Oklahoma atelier this autumn. Press temperatures, music played, the weather of the room.',
    read: '5 min',
    image:
      'https://images.pexels.com/photos/4465124/pexels-photo-4465124.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900',
  },
];

const JournalPage = () => (
  <div data-testid="journal-page">
    <PageHero
      overline="The Journal"
      title={<>Quiet writing on <em className="text-[#90B0BF]">slow beauty</em>.</>}
      subtitle="Letters from the atelier — on ingredients, rituals, provenance, and the patience that makes a house worth keeping."
      testId="journal-hero"
    />

    <section className="px-6 md:px-12 pb-32">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
        {/* Featured */}
        <article
          data-testid="journal-featured"
          className="md:col-span-7 group"
        >
          <div className="relative aspect-[5/4] overflow-hidden mb-6">
            <img
              src={ARTICLES[0].image}
              alt={ARTICLES[0].title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
          </div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF] mb-3">
            <span className="label-divider" />
            {ARTICLES[0].cat} · {ARTICLES[0].read}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#7C9CB1] font-light leading-tight">
            {ARTICLES[0].title}
          </h2>
          <p className="mt-5 text-[#7C9CB1]/85 font-light leading-relaxed max-w-xl text-lg">
            {ARTICLES[0].excerpt}
          </p>
        </article>

        {/* Smaller stack */}
        <div className="md:col-span-5 flex flex-col gap-12">
          {ARTICLES.slice(1).map((a, i) => (
            <article
              key={a.title}
              data-testid={`journal-article-${i}`}
              className="group grid grid-cols-12 gap-5 items-start border-t border-[#C1D7E2] pt-8 first:border-t-0 first:pt-0"
            >
              <div className="col-span-4 relative aspect-square overflow-hidden">
                <img
                  src={a.image}
                  alt={a.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <div className="col-span-8">
                <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF] mb-2">
                  {a.cat} · {a.read}
                </p>
                <h3 className="font-serif text-xl md:text-2xl text-[#7C9CB1] font-light leading-snug">
                  {a.title}
                </h3>
                <p className="mt-3 text-sm text-[#7C9CB1]/85 font-light leading-relaxed">
                  {a.excerpt}
                </p>
                <span className="mt-3 inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.25em] uppercase text-[#7C9CB1]">
                  Read <ArrowUpRight size={12} strokeWidth={1.5} />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default JournalPage;
